// Translate the app's old hash-history URLs to real paths.
//
// japoniacars.pl embedded this app as https://…/#/iframe and
// https://…/#/search?… . Now that it serves clean paths, those URLs have to be
// rewritten *before* the router is constructed — hence a module of its own,
// imported ahead of ./router in main.js, since ES imports are evaluated before
// the importing module's body runs.

const legacy = window.location.hash.match(/^#(\/.*)$/)

if (legacy) {
  window.history.replaceState(null, '', legacy[1])
}

export default legacy ? legacy[1] : null
